import React from 'react';
import { FaCode, FaFigma, FaUserGraduate } from 'react-icons/fa';
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: 'web development',
    text: 'I always strive to code with best practise and find time to code everyday. I´m passionate about Javascript.',
  },
  {
    id: 2,
    icon: <FaFigma className="service-icon" />,
    title: 'web design',
    text: 'I always focus on focus on UX/UI-design when creating. I design prototypes in Figma with the user in mind to create the best experice for people.',
  },
  {
    id: 3,
    icon: <FaUserGraduate className="service-icon" />,
    title: 'web learn',
    text: 'I always want to learn and become the very best developer, both in Front-end but also in Back-end. Learning something new always excites me.',
  },
];
